import { render } from "./TerritoryComp.vue?vue&type=template&id=d0724110&scoped=true"
import script from "./TerritoryComp.vue?vue&type=script&lang=js"
export * from "./TerritoryComp.vue?vue&type=script&lang=js"

import "./TerritoryComp.vue?vue&type=style&index=0&id=d0724110&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0724110"]])

export default __exports__